import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route, withRouter } from 'react-router-dom'
// import CSSTransitionGroup from 'react-addons-css-transition-group'
import { CSSTransitionGroup } from 'react-transition-group'

import EditType from '../components/EditType'
import EditContent from '../components/EditContent'
import EditUser from '../components/EditUser'

const SheetRoute = ({component: Component, ...rest}) =>
  <Route {...rest} render={props =>
    <div className='content sheet' role='sheet'>
      <Component {...props} />
    </div>
  } />

@withRouter
@connect(state => ({sheets: state.ui.sheets}))
export default class Sheets extends Component {
  renderSheet = (sheet, i) => {
    const {component, props} = sheet
    const Component = component === 'EditUser' ? EditUser : EditContent

    return <div key={i} className='content sheet' role='sheet'>
      <Component {...props} isSheet />
    </div>
  }

  renderSheetRoute = (Component, props) => {
    return <div className='content sheet' role='sheet'>
      <Component {...props} />
    </div>
  }

  render () {
    const {sheets, location} = this.props

    return <CSSTransitionGroup
      transitionName='animate'
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}
    >
      <Switch key={location.key} location={location}>
        <SheetRoute exact path='/:siteId/content/:type/edit' component={EditType} />
        <SheetRoute exact path='/:siteId/content/:type/new' component={EditContent} />
        <SheetRoute exact path='/:siteId/content/:type/:id' component={EditContent} />
        <SheetRoute exact path='/:siteId/users/:type/edit' component={EditType} />
        <SheetRoute exact path='/:siteId/users/:type/new' component={EditUser} />
        <SheetRoute exact path='/:siteId/users/:type/:id' component={EditUser} />
      </Switch>
      {!!sheets.length && sheets.map(this.renderSheet)}
    </CSSTransitionGroup>
  }
}



// WEBPACK FOOTER //
// ./app/containers/Sheets.js